// src/elements/Table/Table.Thead.tsx
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var Thead = _ref => {
  let {
    children,
    className
  } = _ref;
  return /* @__PURE__ */jsx("thead", {
    className: clsx("pd:table__thead", className),
    children
  });
};
var Table_Thead_default = Thead;
export { Table_Thead_default };